import { Box } from "@mui/material";
import type { JSX } from "react";

import { Footer } from "../footer";
import { Header } from "../header";

export type SprengnetterPageProps = {
  children: React.ReactNode;
};

export const SprengnetterPage = ({ children }: SprengnetterPageProps): JSX.Element => {
  return (
    <Box
      sx={{
        width: "100%",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",
        backgroundImage: "url(/HomePageBackground.jpg)",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <Header />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          alignSelf: "center",
          gap: 2,
          backgroundColor: (theme) => theme.palette.common.white,
          padding: "100px 50px",
          borderRadius: "3px",
        }}
      >
        {children}
      </Box>
      <Footer />
    </Box>
  );
};
